import React from 'react';
import { Row, Col, Nav, NavItem, Clearfix, Button } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import Masonry from 'react-masonry-component';

import { getTemplateTypes } from 'helpers/cms';
import { getThumbFile } from 'helpers/items';

import RichEditorContent from 'components/RichEditorContent';

class SelectCmsTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeNav: 'public',
      typeFilters: [],
      showMoreInfoId: null,
    };
  }

  handleNav = activeNav => {
    this.setState({ activeNav });
  };

  moreInfos = (e, showMoreInfoId) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showMoreInfoId });
  };

  onFilterClick = (value, checked) => {
    const { typeFilters: stateTypeFilters } = this.state;
    const typeFilters = stateTypeFilters.slice();

    if (checked) {
      typeFilters.push(value);
    } else {
      const valueIndex = typeFilters.indexOf(value);
      if (valueIndex > -1) {
        typeFilters.splice(valueIndex, 1);
      }
    }

    this.setState({ typeFilters });
  };

  renderTemplatesList = list => {
    const { typeFilters } = this.state;

    return (
      <Masonry elementType="div" options={{ transitionDuration: 0 }} disableImagesLoaded={false} updateOnEachImageLoad>
        {list
          .filter(template => {
            if (typeFilters.length) {
              return typeFilters.indexOf(template.type) > -1;
            }

            return true;
          })
          .map(template => this.renderTemplate(template))}
      </Masonry>
    );
  };

  renderTemplate = template => {
    const {
      intl: { messages },
      onSelect,
    } = this.props;
    const { showMoreInfoId } = this.state;
    const { id, preview, name, description } = template;

    let previewThumb;
    if (preview !== undefined) {
      previewThumb = getThumbFile(preview);
    }

    return (
      <Col xs={6} sm={4} md={3} lg={2} key={id}>
        <div className="b-rad-lg bg-master-lightest overflow-hidden cursor" onClick={() => onSelect(template)}>
          {!!previewThumb && <img src={previewThumb.web_link} className="full-width" alt={name} />}

          <div className="padding-15">
            <h5 className="overflow-ellipsis relative p-r-20">
              {name}
              <span className="top-right" onClick={e => this.moreInfos(e, template.id)}>
                <i className="fal fa-info-circle" />
              </span>
            </h5>

            {showMoreInfoId === id && (
              <div className="m-t-15">
                <RichEditorContent content={description} />
              </div>
            )}

            <Button block bsSize="sm" bsStyle="primary" className="m-t-15">
              {messages.use_template}
            </Button>
          </div>
        </div>
      </Col>
    );
  };

  render() {
    const {
      intl: { messages },
      myTemplates,
      publicTemplates,
    } = this.props;
    const { activeNav, typeFilters } = this.state;

    return (
      <Clearfix className="m-t-20">
        <Nav bsStyle="tabs" activeKey={activeNav} onSelect={this.handleNav}>
          <NavItem eventKey="public">{messages.pre_made_layouts}</NavItem>
          <NavItem eventKey="my">{messages.your_existing_pages}</NavItem>
        </Nav>

        <Row>
          <Col xsHidden sm={4} md={3} lg={2} className="no-padding">
            <div className="bg-sidebar padding-15">
              <h3 className="text-white">{messages.categories}</h3>
              {getTemplateTypes(messages).map(systemType => {
                const checked = typeFilters.indexOf(systemType.value) > -1;

                return (
                  <div
                    class="padding-10 cursor"
                    key={systemType.value}
                    onClick={() => this.onFilterClick(systemType.value, !checked)}
                  >
                    <div class="v-align-middle summary-filter-value text-white">
                      <Clearfix>
                        {systemType.label}

                        <div class="pull-right">
                          <i className={checked ? 'fas fa-check-square' : 'fal fa-square'} />
                        </div>
                      </Clearfix>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col xs={12} sm={8} md={9} lg={10}>
            {activeNav === 'public' && (
              <div>
                <h3>
                  <FormattedMessage id="count_templates" values={{ count: publicTemplates.data.count }} />
                </h3>

                {this.renderTemplatesList(publicTemplates.data.list)}
              </div>
            )}

            {activeNav === 'my' && (
              <div>
                <h3>
                  <FormattedMessage id="count_templates" values={{ count: myTemplates.data.count }} />
                </h3>

                {this.renderTemplatesList(myTemplates.data.list)}
              </div>
            )}
          </Col>
        </Row>
      </Clearfix>
    );
  }
}

export default injectIntl(SelectCmsTemplate);
